import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
    constructor(m) {
        super(m);
    }
    
    init() {
        const el = this.el;
        if (!el) {
            return;
        }
        const swiper = new Swiper(el, {
            slidesPerView: 4,
            spaceBetween: 10,
            centeredSlides: false,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 10
                }
            }  
        });
    }
}
